import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentResumoPedido from './ContentResumoPedido';

const App = () => {
  return (
    <>
      <HeaderApp />
      <ContentResumoPedido />
      <Bottom />
    </>
  );
};

export default App;
